export const IS_CREATE_UNIT = "IS_CREATE_UNIT";
export const IS_UPDATE_UNIT = "IS_UPDATE_UNIT";
export const UNIT_LIST = "UNIT_LIST";
export const AFTER_CREATED = "AFTER_CREATED";
export const AFTER_UPDATED = "AFTER_UPDATED";
export const AFTER_DELETED = "AFTER_DELETED";
